import { render } from "./GameVanyaHeader.vue?vue&type=template&id=4c447936&scoped=true"
import script from "./GameVanyaHeader.vue?vue&type=script&lang=js"
export * from "./GameVanyaHeader.vue?vue&type=script&lang=js"

import "./GameVanyaHeader.vue?vue&type=style&index=0&id=4c447936&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c447936"]])

export default __exports__